// These are three simple constants that represent the possible login states

export const NotChecked = 'NotChecked'
export const NotLoggedIn = 'NotLoggedIn'
export const LoggedIn = 'LoggedIn'
